export function getBrowserLocale(options = {}) {
  const supportedLocales = ['ru', 'en'];
  const defaultOptions = { countryCodeOnly: true }

  const opt = { ...defaultOptions, ...options }
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) {
    return 'en'
  }

  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()

  return supportedLocales.includes(trimmedLocale) ? trimmedLocale : 'en';
}
